import { Grid } from '@material-ui/core';
import { ExpandIcon, PlayVideoIcon } from 'app/assets/images/icons';
import CardTitle from 'app/components/CardTitle';
import DotsMenu from 'app/components/DotsMenu';
import ServerError from 'app/components/ErrorBoundary/ServerError';
import Loader from 'app/components/Loader';
import NoData from 'app/components/NoData';
import { useModal } from 'app/context/Modal';
import { getRecentMedia } from 'app/Requests';
import { _t } from 'app/utils/i18n';
import React, { Fragment, FunctionComponent, ReactElement } from 'react';
import { useQuery } from 'react-query';
import { v4 as uuid } from 'uuid';
import styles from './RecentMedia.module.scss';
import DefaultVideo from '../../../app/assets/images/defaultVideo.png';
interface Props {
  mediaData?: any;
  slugName?: any;
  customFilters?: any;
  expandAction?: any;
  compId?: string;
  grid?: any;
  hideIfNoData?: boolean;
  title?: string;
  additionalComponents?: ReactElement;
  isReport?: boolean;
  imageStyle?: any;
  titleStyle?: any;
}
const RecentMedia: FunctionComponent<Props> = ({
  mediaData,
  slugName,
  customFilters,
  expandAction,
  compId,
  grid,
  hideIfNoData,
  title,
  additionalComponents,
  isReport,
  imageStyle,
  titleStyle,
}) => {
  const filters = { ...customFilters };
  const is_instagram = filters.hasOwnProperty('instagram_profile_id');
  const modal = useModal();
  const {
    data: QData,
    isLoading,
    isError,
  } = useQuery(
    ['getRecentMedia', { slug: slugName, body: filters }],
    getRecentMedia,
    { enabled: !!slugName },
  );
  const currentData = !!slugName ? QData : mediaData;
  if (currentData?.length == 0 && hideIfNoData) return <></>;
  return (
    <ServerError requiredApiCalls={[isError]}>
      <Grid item {...grid} id={compId}>
        <CardTitle
          compId={compId}
          title={title || _t('influencers:recent_media')}
          hideIcon={isReport}
          style={titleStyle}
        />
        <div className={styles.RecentMedia}>
          <div className={styles.Actions}>
            {expandAction && (
              <div className={styles.ActionBtn}>
                <ExpandIcon onClick={expandAction} />
              </div>
            )}
            <div className={styles.ActionBtn}>
              {!isReport && <DotsMenu id={compId} />}
            </div>
          </div>
          {!isLoading ? (
            <>
              <div className={styles.imgVidContainer}>
                {currentData?.length > 0 ? (
                  currentData?.map(
                    ({ url, type, thumbnail }: any, index: number) => {
                      return (
                        <Fragment key={index}>
                          {(type === 'VIDEO' ||
                            type === 'IGTV' ||
                            type === 'REEL') &&
                            (thumbnail?.length > 1 ? (
                              <div
                                className={styles.image}
                                // key={index}
                                style={{
                                  cursor: 'pointer',
                                }}
                              >
                                <img
                                  // crossOrigin="anonymous"
                                  src={thumbnail}
                                  alt=""
                                />
                                <div
                                  className={styles.videoHolder}
                                  onClick={() => {
                                    modal.show({
                                      imageUrls: is_instagram
                                        ? undefined
                                        : currentData,
                                      imageIndex: index,
                                      instaMediaUrls: is_instagram
                                        ? currentData
                                        : undefined,
                                    });
                                  }}
                                >
                                  <PlayVideoIcon
                                    className={styles.playerArrow}
                                  />
                                </div>
                              </div>
                            ) : (
                              <div
                                className={styles.image}
                                style={{
                                  cursor: 'pointer',
                                }}
                                onClick={() => {
                                  modal.show({
                                    imageUrls: is_instagram
                                      ? undefined
                                      : currentData,
                                    imageIndex: index,
                                    instaMediaUrls: is_instagram
                                      ? currentData
                                      : undefined,
                                  });
                                }}
                              >
                                <img
                                  // crossOrigin="anonymous"
                                  src={DefaultVideo}
                                  alt=""
                                />
                              </div>
                            ))}

                          {type === 'IMAGE' && (
                            <div
                              className={styles.image}
                              key={uuid()}
                              style={{
                                cursor: 'pointer',
                                ...imageStyle,
                              }}
                            >
                              <img
                                // crossOrigin="anonymous"
                                src={url}
                                alt=""
                                onClick={() => {
                                  modal.show({
                                    imageUrls: currentData,
                                    imageIndex: index,
                                  });
                                }}
                              />
                            </div>
                          )}
                        </Fragment>
                      );
                    },
                  )
                ) : (
                  <NoData />
                )}
              </div>
            </>
          ) : (
            <Loader />
          )}
        </div>
        <div className="position-relative">{additionalComponents}</div>
      </Grid>
    </ServerError>
  );
};

export default RecentMedia;
